import { Icon } from "@/components/atoms";
import { getCardStyles } from "./Card.styles";
import type { CardProps } from "./Card.types";

export const Card = ({
  children,
  title,
  footer,
  showCloseButton,
  onClose,
  withShadow,
  className,
  ...props
}: CardProps) => {
  const styles = getCardStyles({ className, withShadow });

  const hasHeader = title || showCloseButton;

  return (
    <div
      className={styles.wrapper}
      {...props}
    >
      {hasHeader && (
        <div className={styles.header}>
          {title ? <h3 className={styles.title}>{title}</h3> : <div />}

          {showCloseButton && (
            <button
              type="button"
              aria-label="Fechar"
              className={styles.closeButton}
              onClick={onClose}
            >
              <Icon name="times-hexagon" />
            </button>
          )}
        </div>
      )}

      <div className={styles.body}>{children}</div>

      {footer && <div className={styles.footer}>{footer}</div>}
    </div>
  );
};
